import { mapState } from 'vuex';
import AddWidgetDialog from '@/views/dashboards/components/addWidgetDialog.vue';
import DashboardParametersDialog from '@/views/dashboards/components/dashboardParametersDialog.vue';
import DashboardWidgetGrid from '@/views/dashboards/components/dashboardWidgetGrid.vue';
import DashboardToolbar from '@/views/dashboards/components/toolbar.vue';
export default {
  name: 'DashboardRenderer',
  components: {
    AddWidgetDialog,
    DashboardParametersDialog,
    DashboardWidgetGrid,
    DashboardToolbar
  },
  props: {
    activeDashboard: {
      type: Object,
      required: false,
      default: null
    },
    actualDateRange: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    },
    error: {
      type: String,
      required: false,
      default: null
    },
    dashboardLayers: {
      type: Array,
      required: true
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: false
    },
    showFullScreenButton: {
      type: Boolean,
      required: false,
      default: false
    },
    widgetMinSize: {
      type: Number,
      required: false,
      default: null
    },
    showEditModeButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      showAddWidgetDialog: false,
      showParametersDialog: false,
      showDefaultDateRangeSaveDialog: false,
      savingDefaultDateRangeAs: null
    };
  },
  computed: {
    ...mapState('app', ['color']),
    isSavingDefaultDateRange() {
      return this.savingDefaultDateRangeAs !== null;
    }
  },
  watch: {
    actualDateRange: {
      handler() {
        this.refreshWidgetData();
      },
      deep: true
    }
  },
  methods: {
    closeDefaultDateRangeSaveDialog() {
      if (this.isSavingDefaultDateRange) {
        return;
      }
      this.showDefaultDateRangeSaveDialog = false;
    },
    async saveDefaultDateRange(isAbsolute) {
      if (this.isSavingDefaultDateRange) {
        return;
      }
      this.savingDefaultDateRangeAs = isAbsolute ? 'absolute' : 'relative';
      let start = this.actualDateRange.start.getTime();
      let end = this.actualDateRange.end.getTime();
      if (!isAbsolute) {
        start = Date.now() - start;
        end = Date.now() - end;
      }
      const {
        success,
        error
      } = await this.$store.dispatch('dashboards/changeDashboardConfig', {
        dashboardId: this.activeDashboard.id,
        defaultDateRange: {
          isRelative: !isAbsolute,
          start,
          end
        }
      });
      this.savingDefaultDateRangeAs = null;
      if (!success) {
        console.error('error', error);
        this.$snack(this.$t('Dashboards.view.error.savingDefaultDateRange'), 'error');
        return;
      }
      this.showDefaultDateRangeSaveDialog = false;
      this.$snack(this.$t('Dashboards.view.success.savingDefaultDateRange'), 'success');
    },
    refreshWidgetData() {
      if (!this.$refs.dashboardWidgetGrid) {
        return;
      }
      this.$refs.dashboardWidgetGrid.refreshData();
    }
  }
};